
































import CompanyUserRequired from "../CompanyRequired";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "@/components/location/Api";
import {DateTime, HseGuideline, TerminalLocation} from "@/modules/models";
import rd from "@/modules/vRoutedefs";

@Component
export default class HseGuidelineDialog extends CompanyUserRequired {
  @Inject()
  api!: Api;

  @Prop({default: false})
  value!: boolean;

  @Prop({default: false})
  editsDisabled!: boolean;

  get opened() {
    return this.value;
  }
  set opened(v: boolean) {
    this.$emit("input", v);
  }

  @Prop({default: null})
  edit!: HseGuideline | null;

  @Prop()
  location!: TerminalLocation;

  title: string = "";
  contentUrl: string | null = null;
  version: number = 1;

  @Watch("edit", {immediate: true})
  onEditChanged() {
    if(this.edit != null) {
      this.title = this.edit.title;
      this.contentUrl = this.edit.contentUrl;
      this.version = this.edit.version;
    } else {
      this.title = "";
      this.contentUrl = null;
      this.version = 1;
    }
  }

  get isNew() {
    return !this.edit;
  }

  validateTitle() {
    const title = this.title.trim();
    if(title.length < 4) {
      return `Tittel må vere utfyllt med minst 3 bokstaver`;
    } else if(title.length > 150) {
      return `Tittel må ha mindre enn 150 bokstaver`;
    }
    return true;
  }

  validateContentUrl() {
    if(this.contentUrl != null && this.contentUrl.length > 0) {
      try {
        const u = new URL(this.contentUrl);
        if(u.protocol != "https:" && u.protocol != "http:") {
          return "Url må starte med https://";
        }
        if(u.hostname == "anleggsterminal.no") {
          return "Url skal peke til eksternt system, ikke Anleggsterminal";
        }
        return true;
      } catch (e) {
        console.info(`Invalid contentUrl detected`, e);
        return "Ugyldig dokument url spesifisert";
      }
    } else {
      this.contentUrl = null;
      return true;
    }
  }

  validateVersion() {
    if(this.version <= 0) {
      return "Versjonsnummer må være større enn 0";
    } else if(this.version > 100000) {
      return "Versjonsnummer må være mindre enn 100 000";
    }
    return true;
  }

  get allOk() {
    return this.validateTitle() === true && this.validateContentUrl() === true && this.validateVersion() === true;
  }

  private idToSave() {
    if(this.isNew) {
      return 0;
    } else {
      if(this.edit && this.edit.id > 0) {
        return this.edit.id;
      } else {
        throw new Error(`Cannot save HseGuideline without id set`)
      }
    }
  }

  working = false;
  async save() {
    this.working = true;
    try {
      const gl = new HseGuideline(this.idToSave(), this.location.id, this.title.trim(), this.version, this.contentUrl, DateTime.now(), DateTime.now())
      await this.api.setHseGuideline(gl);
      this.$emit("at-hseguideline-changed");
      this.opened = false;
    } finally {
      this.working = false;
    }
  }

  showDeleteConfirm = false;

  deleteConfirm() {
    if(this.location.hseGuidelineEnabled > 0) {
      // verification must be disabled on location before we allow deletion.
      this.emitSnack(`HMS retningslinje bekreftelse må være avskrudd på anlegget før du kan slette`, "error");
    } else {
      this.showDeleteConfirm = true;
    }
  }

  async deleteGuideline() {
    this.working = true;
    try {
      if(this.edit != null) {
        await this.api.deleteHseGuideline(this.edit.id);
      }
      this.$emit("at-hseguideline-deleted");
      this.showDeleteConfirm = false;
      this.opened = false;
    } finally {
      this.working = false;
    }
  }

  get confirmedHseGuidelineReportTo() {
    if(this.location != null) {
      return {name: rd.locations.location.confirmedHseGuidelineReport.name, params: {locationId: this.location.id}};
    } else {
      return {name: rd.locations.name};
    }
  }
}
